<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
  >
    <g :fill="color">
      <path d="M4.125 2.75l13.75 8.25-13.75 8.25z" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SvgPlay',
  props: {
    color: {
      type: String,
      default () {
        return '#fff'
      }
    }
  }
}
</script>
